// extracted by mini-css-extract-plugin
export default {"welcome":"styles_welcome__uMs9g","welcome_active":"styles_welcome_active__iRNYg","modal":"styles_modal__n+QKT"};